<template>
  <v-card class="banner-survey" :elevation="0" :height="560">
    <v-card-text ref="popupRef" v-scroll.self="handleScroll">
      <div class="banner-survey__actions d-flex justify-space-between">
        <transition name="fade" mode="out-in">
          <svgicon v-if="currentQuestionIndex !== 0 && currentStep === 1" @click="handleBackClick" class="banner-survey__back" name="arrow-prev2" :original="true" />
        </transition>
        <svgicon @click="$emit('close')" class="banner-survey__close ms-auto" name="cross-bold" :original="true" />
      </div>

      <!-- desktop -->
      <div class="banner-survey__content" v-if="isWindowMD">
        <transition name="fade" mode="out-in">
          <div class="banner-survey__step --2" :key="currentQuestionIndex" v-if="currentStep === 1">
            <div class="banner-survey__intro">
              <h2 class="banner-survey__intro-title survey-h1 text-center" v-html="poll.NAME"></h2>
            </div>

            <transition name="fade" mode="out-in">
              <v-form 
                :key="currentQuestionIndex+1"
                class="banner-survey__form --desktop" 
                :class="{'--row-flow': currentQuestionIndex === numberOfQuestionGroups - 1}" 
                @submit.prevent="submitSurvey"
              >
                <div v-for="(question, questionIndex) in questionsWithAnswersGrouped" :key="getRealQuestionIndexOfGroup(questionIndex)" class="banner-survey__question">
                  <div class="survey-h2">{{ question.NAME }}</div>
      
                  <v-radio-group  v-model="answers[getRealQuestionIndexOfGroup(questionIndex)]" hide-details @change="saveProgress">
                    <template>
                      <div class="banner-survey__question-answers">
                        <v-radio 
                          v-for="(answer, index) in question.answers" 
                          :key="answer.LETTER" 
                          :value="answer.LETTER" 
                        >
                          <template v-slot:label>
                            <div class="banner-survey__question-answer" :class="{'--selected': answers[getRealQuestionIndexOfGroup(questionIndex)] === answer.LETTER}">
                              <div class="banner-survey__question-answer-letter survey-h3"><span class="abs">{{ answer.LETTER }}</span></div>
                              <div class="banner-survey__question-answer-text survey-size-body">{{ answer.NAME }}</div>
                            </div>
                          </template>
                        </v-radio>
                      </div>
                    </template>
                  </v-radio-group>
                </div>
      
                <v-btn 
                  v-if="currentQuestionIndex !== numberOfQuestionGroups - 1"
                  class="banner-survey__submit"
                  elevation="0"
                  tile
                  outlined
                  :ripple="false"
                  :disabled="currentAnswersGrouped.includes(null)"
                  :loading="isLoading"
                  @click="handleSubmitClick"
                >
                  <span class="survey-size-button">{{ currentQuestionIndex === numberOfQuestionGroups - 1 ? 'Узнать результат' : 'Дальше' }}</span>
                </v-btn>
              </v-form>
            </transition>

            <v-btn 
              class="banner-survey__submit my-auto"
              elevation="0"
              tile
              outlined
              :ripple="false"
              :disabled="currentAnswersGrouped.includes(null) || answers.includes(null)"
              :loading="isLoading"
              @click="handleSubmitClick"
            >
              <span class="survey-size-button">{{ currentQuestionIndex === numberOfQuestionGroups - 1 ? 'Узнать результат' : 'Продолжить' }}</span>
            </v-btn>
  
            <transition name="fade" mode="out-in">
              <div class="banner-survey__step-bg --2" v-if="currentQuestionIndex" key="step-2">
                <v-img class="banner-survey__step-bg-prop --praline-3" contain src="@/assets/banner-line-survey/prop-praline-3.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --bird" contain src="@/assets/banner-line-survey/prop-bird.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --star-1" contain src="@/assets/banner-line-survey/prop-star-1.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --star-2" contain src="@/assets/banner-line-survey/prop-star-2.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --star-3" contain src="@/assets/banner-line-survey/prop-star-3.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --star-3 --4" contain src="@/assets/banner-line-survey/prop-star-3.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --star-3 --5" contain src="@/assets/banner-line-survey/prop-star-3.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --tree-2" contain src="@/assets/banner-line-survey/prop-tree-2.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --cloud-2 --2" contain src="@/assets/banner-line-survey/prop-cloud-2.webp"></v-img>
              </div>

              <div class="banner-survey__step-bg --1" v-else key="step-1">
                <v-img class="banner-survey__step-bg-prop --praline-2" contain src="@/assets/banner-line-survey/prop-praline-2.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --cloud" contain src="@/assets/banner-line-survey/prop-cloud.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --cloud-2" contain src="@/assets/banner-line-survey/prop-cloud-2.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --star-1" contain src="@/assets/banner-line-survey/prop-star-1.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --star-3" contain src="@/assets/banner-line-survey/prop-star-3.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --star-3 --2" contain src="@/assets/banner-line-survey/prop-star-3.webp"></v-img>
                <v-img class="banner-survey__step-bg-prop --star-3 --3" contain src="@/assets/banner-line-survey/prop-star-3.webp"></v-img>
              </div>
            </transition>
          </div>
    
          <div class="banner-survey__step --3" :key="'result'" v-else>
            <div class="banner-survey__result" v-if="results">
              <div class="banner-survey__result-heading" v-if="results.PREVIEW_TEXT">
                <div class="survey-h1" v-html="results.PREVIEW_TEXT"></div>
              </div>
  
              <div class="banner-survey__result-subheading survey-h2" v-html="results.DETAIL_TEXT" v-if="results.DETAIL_TEXT"></div>
  
              <div class="banner-survey__products">
                <div class="banner-survey__product">
                  <v-img class="banner-survey__product-img" :src="selectedProduct.PREVIEW_PICTURE" contain></v-img>
                  <div class="banner-survey__product-title survey-h3" v-html="selectedProduct.NAME"></div>
                  <div class="banner-survey__product-text survey-size-body-3" v-html="selectedProduct.SUBNAME"></div>
                </div>
              </div>

              <div class="banner-survey__hint">
                {{ poll.DESCRIPTION }}
              </div>
  
              <v-btn 
                class="banner-survey__submit"
                elevation="0"
                tile
                outlined
                :ripple="false"
                :loading="isLoading"
                @click="handleResultBtnClick"
              >
                <span class="survey-size-button">положить в корзину</span>
              </v-btn>
            </div>
  
            <div class="banner-survey__step-bg">
              <v-img class="banner-survey__step-bg-prop --horse" contain src="@/assets/banner-line-survey/prop-horse.webp"></v-img>
              <v-img class="banner-survey__step-bg-prop --cloud" contain src="@/assets/banner-line-survey/prop-cloud.webp"></v-img>
              <v-img class="banner-survey__step-bg-prop --star-2" contain src="@/assets/banner-line-survey/prop-star-2.webp"></v-img>
              <v-img class="banner-survey__step-bg-prop --star-2 --2" contain src="@/assets/banner-line-survey/prop-star-2.webp"></v-img>
              <v-img class="banner-survey__step-bg-prop --star-3" contain src="@/assets/banner-line-survey/prop-star-3.webp"></v-img>
            </div>
          </div>
        </transition>
      </div>

      <!-- mobile -->
      <div class="banner-survey__content" v-else>
        <svgicon @click="scrollToTop" class="banner-survey__back" :class="{'--scrolled': isPopupScrolled}" name="arrow-up" :original="true" />

        <div class="banner-survey__intro">
          <h2 class="banner-survey__intro-title survey-h1 text-center" v-html="poll.NAME"></h2>

          <div class="banner-survey__step-bg">
            <v-img class="banner-survey__step-bg-prop --lion" contain src="@/assets/banner-line-survey/prop-lion.webp"></v-img>
            <v-img class="banner-survey__step-bg-prop --horse" contain src="@/assets/banner-line-survey/prop-horse.webp"></v-img>
            <v-img class="banner-survey__step-bg-prop --praline" contain src="@/assets/banner-line-survey/prop-praline-1.webp"></v-img>
            <v-img class="banner-survey__step-bg-prop --cloud" contain src="@/assets/banner-line-survey/prop-cloud.webp"></v-img>
            <v-img class="banner-survey__step-bg-prop --star-1" contain src="@/assets/banner-line-survey/prop-star-1.webp"></v-img>
            <v-img class="banner-survey__step-bg-prop --star-2" contain src="@/assets/banner-line-survey/prop-star-2.webp"></v-img>
            <v-img class="banner-survey__step-bg-prop --star-3" contain src="@/assets/banner-line-survey/prop-star-3.webp"></v-img>
          </div>
        </div>

        <v-form class="banner-survey__form --mobile" @submit.prevent="submitSurvey">
          <div v-for="(question, questionIndex) in questionsWithAnswers" :key="questionIndex" class="banner-survey__question">
            <div class="survey-h2">{{ question.NAME }}</div>

            <v-radio-group v-model="answers[questionIndex]" hide-details :readonly="!!results" @change="saveProgress">
              <template>
                <div class="banner-survey__question-answers">
                  <v-radio 
                    v-for="(answer, index) in question.answers" 
                    :key="answer.LETTER" 
                    :value="answer.LETTER" 
                  >
                    <template v-slot:label>
                      <div class="banner-survey__question-answer" :class="{'--selected': answers[questionIndex] === answer.LETTER}">
                        <div class="banner-survey__question-answer-letter survey-h3"><span class="abs">{{ answer.LETTER }}</span></div>
                        <div class="banner-survey__question-answer-text survey-size-body">{{ answer.NAME }}</div>
                      </div>
                    </template>
                  </v-radio>
                </div>
              </template>
            </v-radio-group>
          </div>

          <transition name="fade" mode="out-in">
            <v-btn 
              v-if="!results"
              class="banner-survey__submit"
              elevation="0"
              tile
              outlined
              type="submit"
              :ripple="false"
              :loading="isLoading"
              :disabled="answers.includes(null)"
            >
              <span class="survey-size-button">Узнать результат</span>
            </v-btn>
          </transition>

          <div class="banner-survey__step-bg">
            <v-img class="banner-survey__step-bg-prop --bird" contain src="@/assets/banner-line-survey/prop-bird.webp"></v-img>
            <v-img class="banner-survey__step-bg-prop --praline" contain src="@/assets/banner-line-survey/prop-praline-2.webp"></v-img>
            <v-img class="banner-survey__step-bg-prop --cloud" contain src="@/assets/banner-line-survey/prop-cloud.webp"></v-img>
            <v-img class="banner-survey__step-bg-prop --cloud --2" contain src="@/assets/banner-line-survey/prop-cloud.webp"></v-img>
          </div>
        </v-form>

        <transition name="fade" mode="out-in">
          <div class="banner-survey__result" v-if="results">
            <div class="banner-survey__result-heading" v-if="results.PREVIEW_TEXT">
              <div class="survey-h1" v-html="results.PREVIEW_TEXT"></div>
            </div>
  
            <div class="banner-survey__result-subheading survey-h3" v-html="results.DETAIL_TEXT" v-if="results.DETAIL_TEXT"></div>
  
            <div class="banner-survey__products">
              <div class="banner-survey__product">
                <v-img class="banner-survey__product-img" :src="selectedProduct.PREVIEW_PICTURE" contain></v-img>
                <div class="banner-survey__product-title survey-h3" v-html="selectedProduct.NAME"></div>
                <div class="banner-survey__product-text survey-size-body-3" v-html="selectedProduct.SUBNAME"></div>
              </div>
            </div>

            <div class="banner-survey__hint">
              {{ poll.DESCRIPTION }}
            </div>
  
            <v-btn 
              class="banner-survey__submit"
              elevation="0"
              tile
              outlined
              :ripple="false"
              :loading="isLoading"
              @click="handleResultBtnClick"
            >
              <span class="survey-size-button">положить в корзину</span>
            </v-btn>
  
            <div class="banner-survey__step-bg">
              <v-img class="banner-survey__step-bg-prop --cloud" contain src="@/assets/banner-line-survey/prop-cloud-2.webp"></v-img>
              <v-img class="banner-survey__step-bg-prop --cloud --2" contain src="@/assets/banner-line-survey/prop-cloud-2.webp"></v-img>
              <v-img class="banner-survey__step-bg-prop --star-2" contain src="@/assets/banner-line-survey/prop-star-2.webp"></v-img>
            </div>
          </div>
        </transition>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'banner-survey',
  data: () => {
    return {
      isLoading: false,
      // не null: шаблон читает answers[index] уже на первом рендере, до mounted() -
      // на null это падает с "Cannot read properties of null", на [] - безопасно (undefined)
      answers: [],
      currentStep: 1,
      currentQuestionIndex: 0,
      results: null,
      selectedProduct: null,
      questionsPerPage: 3,
      isPopupScrolled: false,
      passId: null,
      visitorId: null,
    }
  },
  computed: {
    isWindowMD() {
      return this.$store.getters.isWindowMD;
    },
    // state.response.page перетирается ответом каждой страницы, опрос с внутренних страниц дублируется в state.page.PollController
    poll() {
      return this.$store.state.response?.page?.PollController?.poll || this.$store.state.page?.PollController?.poll || this.$store.state.page?.HomeController?.poll;
    },
    pollQuestions() {
      return this.$store.state.response?.page?.PollController?.questions || this.$store.state.page?.PollController?.questions || this.$store.state.page?.HomeController?.pollQuestions;
    },
    pollAnswers() {
      return this.$store.state.response?.page?.PollController?.answers || this.$store.state.page?.PollController?.answers || this.$store.state.page?.HomeController?.pollAnswers;
    },
    questionsWithAnswers() {
      return this.pollQuestions?.map(question => {
        const answersToQuestion = this.pollAnswers?.filter(answer => answer?.IBLOCK_SECTION_ID === question?.ID);

        return {
          ...question,
          answers: answersToQuestion,
        }
      });
    },
    questionsWithAnswersGrouped() {
      const start = this.questionsPerPage * this.currentQuestionIndex;
      return this.questionsWithAnswers?.slice(start, start + this.questionsPerPage);
    },
    currentAnswersGrouped() {
      const start = this.questionsPerPage * this.currentQuestionIndex;
      return this.answers?.slice(start, start + this.questionsPerPage);
    },
    numberOfQuestions() {
      return this.questionsWithAnswers?.length;
    },
    numberOfQuestionGroups() {
      return Math.ceil(this.numberOfQuestions / this.questionsPerPage);
    },
  },
  methods: {
    getRealQuestionIndexOfGroup(index) {
      return index + this.questionsPerPage * this.currentQuestionIndex;
    },
    generatePassId() {
      this.passId = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    },
    // персистентный id браузера - в отличие от passId не сбрасывается между прохождениями,
    // позволяет в отчёте видеть повторные прохождения одного и того же браузера
    getOrCreateVisitorId() {
      const storageKey = 'pollVisitorId';
      try {
        let id = localStorage.getItem(storageKey);
        if (!id) {
          id = (window.crypto && window.crypto.randomUUID)
            ? window.crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
          localStorage.setItem(storageKey, id);
        }
        this.visitorId = id;
      } catch (err) {
        console.log(err);
      }
    },
    resetSurvey() {
      this.currentStep = 1;
      this.currentQuestionIndex = 0;
      this.answers = this.answers.map(a => null);
      this.selectedProduct = null;
      this.results = null;
      this.generatePassId();
    },
    // сохраняет прогресс прохождения при каждом выборе ответа - в т.ч. незавершённые прохождения
    saveProgress() {
      this.$store.dispatch('post', {
        action: 'PollProgressController',
        params: {
          code: this.poll?.CODE,
          passId: this.passId,
          visitorId: this.visitorId,
          answers: this.answers,
        },
      }).catch((err) => {
        console.log(err);
      });
    },
    submitSurvey() {
      console.log('submitting with answers: ', this.answers);
      this.isLoading = true;

      this.$store.dispatch('post', {
        action: 'PollController',
        params: {
          code: this.poll?.CODE,
          passId: this.passId,
          visitorId: this.visitorId,
          answers: this.answers,
        },
      }).then((res) => {
        console.log('res', res);
        this.results = res?.page?.PollController?.pollResult;
        this.selectedProduct = res?.page?.PollController?.product;
        this.currentStep = 3;
        console.log('results', this.results)

        setTimeout(() => {
          if(!this.$refs.popupRef) return;

          this.$refs.popupRef.scrollTo({
            top: this.$refs.popupRef.scrollHeight,
            behavior: 'smooth'
          });
        }, 300);
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    handleSubmitClick() {
      if(this.currentQuestionIndex === this.numberOfQuestionGroups - 1) {
        this.submitSurvey();
        return;
      }

      this.currentQuestionIndex += 1;
    },
    handleBackClick() {
      if(this.currentQuestionIndex !== 0) {
        this.currentQuestionIndex -= 1;
        return;
      }

      this.currentStep -= 1;
    },
    handleResultBtnClick() {
      console.log('selectedProduct', this.selectedProduct);
      this.isLoading = true;

      this.$store.dispatch('post', {
				action: 'BasketAddController',
				params: {
					productId: this.selectedProduct?.ID,
					amount: 1,
					pollPassId: this.passId,
				},
			}).then((result) => {
				this.$store.commit('setSession', result);
        this.resetSurvey();
        this.$emit('close');
			}).catch((error) => {
        console.log(error);
				// this.error = error?.message;
				//this.isSnackError = true;
			}).finally(() => {
				this.isLoading = false;
			});
    },
    handleScroll() {
      console.log('scroll event')
      console.log('this.$refs.popupRef.scrollTop', this.$refs.popupRef.scrollTop)
      if (this.$refs.popupRef.scrollTop > 400) this.isPopupScrolled = true;
			else this.isPopupScrolled = false;
    },
    scrollToTop() {
      if(!this.$refs.popupRef) return;

      this.$refs.popupRef.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    
  },
  mounted() {
    console.log('questionsWithAnswers', this.questionsWithAnswers);
    console.log('numberOfQuestions', this.numberOfQuestions);
    console.log('numberOfQuestionGroups', this.numberOfQuestionGroups);
    console.log('currentQuestionIndex', this.currentQuestionIndex);
    this.answers = new Array(this.numberOfQuestions).fill(null);
    this.generatePassId();
    this.getOrCreateVisitorId();
    console.log('currentAnswersGrouped', this.currentAnswersGrouped);
  },
}
</script>

<style lang="scss">
@import "@/styles/survey/typo";

.banner-survey {
  position: relative;

  &.v-card {
    background-color: $gray2 !important;
    display: flex;
    overflow: hidden;
    
    @include up($md) {
      border-radius: 22px !important;
    }

    .v-card__text {
      padding: 0 !important;
      min-height: 100%;
      flex-grow: 1;
    }
  }

  &__actions {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding: 20px;
    z-index: 2;
  }

  &__close, &__back {
    width: 16px;
    min-width: 16px;
    cursor: pointer;
  }

  &__back {
    fill: none;
  }

  &__step {
    position: absolute;
    width: 100%;
    min-height: 100%;
    padding: 30px 0;
    overflow: hidden;

    &-bg {
      width: 100%;
      overflow: hidden;
      position: absolute;
      z-index: 0;
      inset: 0;
      
      @include up($md) {
        max-height: 560px;
      }

      &-prop {
        display: block;
        position: absolute !important;
        z-index: 0;
      }
    }

    & > *:not(.banner-survey__step-bg) {
      position: relative;
      z-index: 1;
    }

    &.--1 {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      text-align: center;
      
      h2 {
        max-width: 140px;
        
        @include up($md) {
          max-width: 180px;
        }
      }

      .banner-survey__submit {
        width: 180px !important;
      }

      .banner-survey__step-bg-prop {
        &.--praline {
          width: 176px;
          height: 175px;

          @include up($md) {
            width: 244px;
            height: 243px;
          }
        }

        &.--lion {
          z-index: 1;
          top: 50%;
          left: 50%;
          width: 326px;
          height: 235px;
          transform: translate(-105%, -58%);
          
          @include up($md) {
            transform: none;
            top: 95px;
            left: 61px;
            width: 359px;
            height: 258px;
          }
        }

        &.--horse {
          z-index: 1;
          top: 50%;
          right: 50%;
          width: 291px;
          transform: translate(102%, -20%) rotate(8.72deg);
          
          @include up($md) {
            transform: none;
            top: 165px;
            right: 72px;
            width: 342px;
          }
        }

        &.--bird {
          z-index: 1;
          top: 36px;
          right: 16px;
          width: 99px;

          @include up($md) {
            top: 25px;
            right: 92px;
            width: 148px;
          }
        }

        &.--tree {
          bottom: -234px;
          left: -128px;
          width: 241px;
          height: 464px;
          
          @include up($md) {
            bottom: -202px;
            left: -56px;
            width: 291px;
            height: 540px;
          }
        }

        &.--cloud {
          transform: scale(-1, 1);
          top: 5px;
          left: 3px;
          width: 89px;

          @include up($md) {
            top: 5px;
            left: -42px;
            width: 127px;
          }

          &.--2 {
            left: unset;
            transform: none;
            top: 127px;
            right: -36px;
            width: 77px;

            @include up($md) {
              top: 141px;
              right: -51px;
              width: 144px;
            }
          }
        }

        &.--star-1 {
          z-index: 1;
          top: 142px;
          left: 18px;
          top: 50%;
          left: 50%;
          width: 43px;
          transform: translate(-335%, -125%);

          @include up($md) {
            transform: none;
            top: 159px;
            left: 228px;
            width: 53px;
          }
        }

        &.--star-2 {
          z-index: 1;
          bottom: 3px;
          right: 52px;
          width: 24px;

          @include up($md) {
            right: unset;
            bottom: 16px;
            left: 71px;
            width: 40px;
          }

          &.--2 {
            bottom: unset;
            top: 62px;
            left: 92px;

            @include up($md) {
              left: unset;
              top: 62px;
              right: 330px;
            }
          }
        }

        &.--star-3 {
          z-index: 1;
          top: 50%;
          right: 50%;
          width: 18px;
          transform: translate(305%, 370%) rotate(8.72deg);

          @include up($md) {
            transform: none;
            top: unset;
            bottom: 164px;
            right: 342px;
            width: 20px;
          }

          &.--2 {
            transform: none;
            bottom: unset;
            left: unset;
            top: 148px;
            right: 39px;
            width: 12px;

            @include up($md) {
              top: 172px;
              right: 82px;
              width: 20px;
            }
          }

          &.--3 {
            transform: none;
            bottom: unset;
            left: unset;
            width: 5px;
            top: 147px;
            right: 36px;

            @include up($md) {
              width: 8px;
              top: 166px;
              right: 73px;
            }
          }
        }
      }
    }

    &.--2 {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 40px;
      padding: 30px 72px;

      .banner-survey__step-bg-prop {
        &.--praline-2 {
          z-index: 1;
          width: 312px;
          bottom: 0;
          right: 0;
        }

        &.--praline-3 {
          z-index: 1;
          width: 338px;
          height: 338px;
          bottom: -72px;
          left: 0px;
        }

        &.--bird {
          z-index: 1;
          width: 151px;
          top: 30px;
          right: 42px;
        }

        &.--tree-2 {
          bottom: -22px;
          right: -57px;
          width: 345px;
          height: 368px;
        }

        &.--cloud {
          top: 154px;
          right: -50px;
          width: 161px;
          height: 117px;
        }

        &.--cloud-2 {
          bottom: 180px;
          left: -131px;
          width: 218px;
          height: 99px;

          &.--2 {
            left: unset;
            bottom: -63px;
            right: -51px;
            width: 287px;
            height: 130px;
          }
        }

        &.--star-1 {
          z-index: 1;
          top: 62px;
          left: 22px;
          width: 63px;
        }

        &.--star-2 {
          z-index: 1;
          top: 320px;
          left: 50%;
          width: 58px;
          transform: translateX(-50%);
        }

        &.--star-3 {
          z-index: 2;
          bottom: 13px;
          right: 182px;
          width: 20px;

          &.--2 {
            bottom: unset;
            top: 83px;
            right: 111px;
          }

          &.--3 {
            bottom: unset;
            top: 72px;
            right: 134px;
            width: 10px;
          }

          &.--4 {
            bottom: 46px;
            right: 170px;
          }

          &.--5 {
            bottom: 36px;
            right: 205px;
            width: 10px;
          }
        }
      }
    }

    &.--3 {
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      .banner-survey__step-bg-prop {
        &.--horse {
          z-index: 1;
          transform: none;
          top: 135px;
          right: -38px;
          width: 387px;
        }

        &.--cloud {
          left: 5px;
          bottom: 63px;
          width: 220px;
          height: 138px;
        }

        &.--star-2 {
          z-index: 1;
          bottom: 168px;
          left: 202px;
          width: 47px;

          &.--2 {
            left: unset;
            bottom: 221px;
            right: 282px;
            width: 66px;
          }
        }

        &.--star-3 {
          z-index: 2;
          top: 176px;
          right: 50px;
          width: 23px;
        }
      }
    }
  }

  &__content {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 100px;
    min-height: 100%;

    @include up($md) {
      gap: 40px;
    }

    .banner-survey__back {
      position: fixed;
      z-index: 10;
      bottom: 58px;
      width: 50px;
      padding: 10px 16px;
      opacity: 0;
      pointer-events: none;
      @include transition();

      &.--scrolled {
        opacity: 1;
        pointer-events: all;
      }
    }
  }

  &__intro {
    position: relative;
    display: flex;
    justify-content: center;
    min-height: 368px;
    padding-top: 60px;
    
    @include up($md) {
      min-height: 0;
      padding-top: 0;
    }

    &-title {
      max-width: 250px;

      @include up($md) {
        max-width: 100%;
      }
    }

    .banner-survey__step-bg {
      &-prop {
        &.--praline {
          width: 212px;
          height: 212px;
          top: 164px;
          left: 50%;
          transform: translateX(-50%);
        }

        &.--lion {
          z-index: 1;
          top: 128px;
          left: 50%;
          width: 339px;
          transform: translate(-111%, 0);
        }

        &.--horse {
          z-index: 1;
          top: 159px;
          right: 50%;
          width: 287px;
          transform: translate(108%, 0);
        }

        &.--cloud {
          transform: scale(-1, 1);
          top: 27px;
          left: -35px;
          width: 89px;
        }

        &.--star-1 {
          width: 43px;
          z-index: 1;
          top: 191px;
          left: 50%;
          transform: translate(-370%, 0);
        }

        &.--star-2 {
          z-index: 1;
          top: 133px;
          right: 31px;
          width: 45px;
        }

        &.--star-3 {
          z-index: 1;
          top: 50%;
          right: 50%;
          width: 14px;
          transform: translate(1200%, 200%);
        }
      }
    }
  }

  &__form {
    position: relative;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, minmax(1fr, 338px));
    justify-content: center;
    gap: 40px;
    padding: 0 50px 60px;

    @include up($md) {
      width: 100%;
      display: grid;
      grid-template-rows: repeat(2, min-content);
      grid-template-columns: repeat(2, 355px);
      grid-auto-flow: column;
      justify-content: space-around;
      gap: 40px 50px;
      padding: 0;
    }

    &.--row-flow {
      grid-auto-flow: row !important;
    }

    .v-btn {
      justify-self: center;
      
      @include up($md) {
        justify-self: start;
        width: 110px !important;
      }
    }

    & > *:not(.banner-survey__step-bg) {
      position: relative;
      z-index: 1;
    }
    
    .banner-survey__step-bg {
      &-prop {
        &.--praline {
          width: 147px;
          right: -32px;
          top: 680px;
        }

        &.--bird {
          z-index: 1;
          right: 5px;
          top: 1000px;
          width: 147px;
        }

        &.--cloud {
          top: 885px;
          left: -85px;
          width: 140px;

          &.--2 {
            left: unset;
            top: 210px;
            right: -36px;
            width: 109px;
          }
        }
      }
    }
  }

  &__question {
    display: flex;
    flex-direction: column;
    gap: 15px;

    .v-input.v-input--radio-group {
      margin: 0 !important;
      padding: 0 !important;

      .v-radio {
        margin: 0 !important;
        width: fit-content;

        .v-input--selection-controls__input {
          display: none; 
        }
      }
    }

    &-answers {
      display: flex;
      flex-direction: column;
      gap: 13px;
    }

    &-answer {
      display: flex;
      align-items: center;
      gap: 10px;

      &.--selected, &:hover {
        .banner-survey__question-answer-letter {
          color: $white;
          background-color: $golden;
        }
      }

      &-letter {
        flex-shrink: 0;
        letter-spacing: 0 !important;
        position: relative;
        color: $golden;
        border: 1px solid $golden;
        border-radius: 50%;
        width: 26px;
        height: 26px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;
        @include transition();
      }
    }
  }

  &__submit {
    width: 210px;
    height: 44px !important;
    border: 2px solid $golden;
    color: $golden !important;
    padding: 0 25px !important;
    @include transition();

    &:hover {
      color: $white !important;
      background-color: $golden;
    }

    &[disabled], &.v-btn--disabled {
      opacity: 0.25;
    }
    
  }
  
  .theme--light.v-btn.v-btn--disabled {
    color: $golden !important;
  }

  &__result {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 50px 90px;

    @include up($md) {
      padding: 60px 55px;
    }

    &-heading {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 10px;
    }

    &-subheading {
      margin-bottom: 35px;
      
      @include up($md) {
        margin-bottom: 25px;
      }
    }

    & > *:not(.banner-survey__step-bg) {
      position: relative;
      z-index: 1;
    }
    
    .banner-survey__step-bg {
      overflow: visible;

      &-prop {
        &.--cloud {
          top: -140px;
          left: -46px;
          width: 296px;
          height: 135px;

          &.--2 {
            top: unset;
            left: unset;
            bottom: -42px;
            right: -72px;
          }
        }

        &.--star-2 {
          bottom: 220px;
          right: 20px;
          width: 58px;
        }
      }
    }
  }

  &__products {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 5px;
    
    @include up($md) {
      flex-direction: row;
      gap: 55px;
    }
  }

  &__product {
    width: 100%;
    text-align: center;
    border: 1px solid transparent;
    border-radius: 5px;
    @include transition();

    &-img {
      height: 165px;
    }

    &-title {
      margin: 15px 0 0;
    }

    &-text {
      color: $golden;
    }
  }

  &__hint {
    margin-bottom: 10px;
  }
}
</style>